<template>
  <div>
    <!--  請求製品選択画面 -->
    <t-card v-loading="loading">
      <!-- 請求製品選択 -->
      <div :style="{ height: basicHeight + 'px', 'padding-top': '10px' }">
        <t-form
          :model="reqInfoEditForm"
          label-position="right"
          label-width="100px"
        >
          <t-row>
            <t-col :span="colArr.colL">&nbsp;</t-col>

            <!-- 得意先 -->
            <t-col :span="colArr.colCom">
              <t-form-item
                :label="$t('resource.REQUEST_INFO.CUS_DATA')"
                class="marginBottom"
              >
                <t-input
                  v-if="this.isAdd"
                  v-model="reqInfoEditForm.rbCusInfo"
                  readonly
                  class="commonDialog"
                  style="margin-top: 6px"
                  @click.native="customerReferenceClick()"
                >
                  <t-button
                    slot="append"
                    class="button-default custom-button"
                    icon="el-icon-circle-close"
                    @click.native.stop="clearClick"
                  ></t-button>
                </t-input>
                <t-input
                  v-else
                  v-model="reqInfoEditForm.rbCusInfo"
                  disabled
                  class="commonDialog"
                  style="margin-top: 6px"
                  @click.native="customerReferenceClick()"
                >
                  <t-button
                    slot="append"
                    icon="el-icon-circle-close"
                    @click.native.stop="clearClick"
                  ></t-button>
                </t-input>
              </t-form-item>
            </t-col>

            <t-col :span="colArr.colCom * 1.5">
              <t-form-item
                :label="$t('resource.REQUEST_INFO.REQUEST_EXPECTED_DATE')"
                class="marginBottom"
              >
                <t-date-picker
                  v-model="reqInfoEditForm.quoteDateRange"
                  type="daterange"
                  :clearable="false"
                  class="date_icon_center"
                  range-separator="～"
                  start-placeholder="開始日"
                  end-placeholder="終了日"
                  value-format="yyyy/MM/dd"
                  format="yyyy/MM/dd"
                  style="min-width: 20px; width: 75%; margin-top: 8px"
                  :editable="false"
                >
                </t-date-picker>
              </t-form-item>
            </t-col>

            <!-- ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓ -->
            <!-- 一式機能の追加 -->
            <t-col :span="colArr.colCom * 0.5" class="center">
              <template>
                <t-checkbox
                  v-model="aobASetOnly"
                  :label="$t('resource.SEND.A_SET_ONLY')"
                  style="line-height: 3"
                />
              </template>
            </t-col>
            <!-- ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑ -->

            <t-col :span="colArr.colCom" class="center">
              <!-- 検索 -->
              <t-button
                round
                type="primary"
                class="dialogButton_120_40"
                style="margin-top: 0"
                ref="searchBtn"
                @click="searchClick()"
              >
                <i class="el-icon-search"></i>
                {{ $t("resource.sys.search") }}
              </t-button>
            </t-col>

            <t-col :span="colArr.colR">&nbsp;</t-col>
          </t-row>
        </t-form>
      </div>

      <div>
        <t-row class="marginBottom">
          <t-col
            :span="parseInt($t('widgetSize.ReceOrderSelectDialog.colOneSpan'))"
          >
            <!-- テーブル -->
            <div>
              <t-table
                ref="requestProductForm"
                :data="requestProductForm"
                class="table_common"
                header-cell-class-name="bg-default"
                :height="detailHeight"
                highlight-current-row
                @selection-change="handleRowClick"
                border
                fit
              >
                <!-- 選択ボックス -->
                <t-table-column
                  prop="selected"
                  type="selection"
                  class-name="cell_txt_center"
                />

                <!-- テーブルの列 -->
                <t-table-column
                  v-for="(column, index) in columns"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :min-width="column.width"
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="column.class"
                  :show-overflow-tooltip="column.overflowTooltip"
                >
                </t-table-column>
              </t-table>
            </div>
          </t-col>
        </t-row>
      </div>
      <div :style="{ height: bottomHeight + 'px' }">
        <t-row class="marginBottom">
          <div>
            <t-col :span="20">&nbsp;</t-col>
            <t-col :span="4" class="right">
              <t-button
                round
                type="warning"
                class="dialogButton_confirm_120_40"
                ref="confirmBtn"
                @click="confirmClick"
              >
                <i class="el-icon-check"></i>
                {{ $t("resource.sys.sure") }}</t-button
              >
            </t-col>
          </div>
        </t-row>
      </div>
    </t-card>
  </div>
</template>
<script>
import { ShowCustomerReferenceDialog } from "@/components/Dialog";
import { t } from "@/locales";
import { getReqDetailInfo, getReqProductInfo } from "@/services/requestInfo";
import {
  formatDateToString,
  formatStringToDate,
  getDialogContentHeight,
  getEditColWidthArr,
  getNextMonthAgoArray,
} from "@/utils/comFunction";
import { DIALOG_LINE_HEIGHT } from "@/utils/const";
import { flexColumnWidth, setColumnWidth } from "@/utils/table";
import { Message, Modal } from "@tellus/component";
export default {
  data() {
    return {
      reqInfoEditForm: {
        // 請求予定日
        quoteDateRange: "",
        // 得意先
        rbCusInfo: "",
        // 請求予定日
        rbRequestExpectedDate: "",
        // 請求予定日(開始日)
        startDate: "",
        // 請求予定日(終了日)
        endDate: "",
        // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
        aobASetOnly: "", //一式のみ
        // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
      },

      // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
      // 一式機能の追加
      aobASetOnly: false,
      // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑

      loading: false,
      //受注一覧選択情報
      requestProductForm: [],

      //列の幅
      colArr: getEditColWidthArr(window.innerWidth, 4),

      //仕入先見積依頼のテーブルの列
      columns: [
        // 得意先
        {
          prop: "rbCusInfo",
          label: t("resource.REQUEST_INFO.CUS_DATA"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        {
          // 出荷No
          prop: "sbSendNo",
          label: t("resource.REQUEST_INFO.SEND_NO"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: false,
        },
        // 出荷日
        {
          prop: "sbSendDate",
          label: t("resource.REQUEST_INFO.SEND_DATE"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },
        // 請求予定日
        {
          prop: "rbRequestExpectedDate",
          label: t("resource.REQUEST_INFO.REQUEST_EXPECTED_DATE"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },
      ],

      //現在選択されているセル
      currentCell: [],

      //基本情報のheight
      basicHeight: DIALOG_LINE_HEIGHT,
      //明細情報のheight
      detailHeight: getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT,
        DIALOG_LINE_HEIGHT,
        30
      ),
      //確定ボタンのheight
      bottomHeight: DIALOG_LINE_HEIGHT,

      yourDesiredColor: "#FF0000",
    };
  },

  props: {
    isAdd: {
      Type: Boolean,
      default: false,
    },
    ReqInfoEditForm: {
      Type: Object,
    },
    RowData: {
      Type: Object,
    },
    RbRequestExpectedDate: {
      Type: Object,
    },
    reqNo: {
      Type: Object,
      default: "false",
    },
  },
  mounted() {
    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);

    // 初期化
    this.init();
  },

  watch: {
    // 請求日
    "reqInfoEditForm.quoteDateRange"(value) {
      // 請求日処理
      this.editDate(value);
    },
  },

  methods: {
    // 初期化
    init() {
      // 請求予定日(開始日)
      this.reqInfoEditForm.startDate = this.ReqInfoEditForm.startDate;

      // 請求予定日(終了日)
      this.reqInfoEditForm.endDate = this.ReqInfoEditForm.endDate;

      // 請求予定日
      this.reqInfoEditForm.rbRequestExpectedDate =
        this.ReqInfoEditForm.rbRequestExpectedDate;

      // 得意先
      this.reqInfoEditForm.rbCusInfo = this.ReqInfoEditForm.rbCusInfo;

      // 請求予定日
      this.reqInfoEditForm.quoteDateRange = this.ReqInfoEditForm.quoteDateRange;

      this.reqInfoEditForm.requestNo = this.reqNo;

      // 既に存在する日付を使用する
      if (!this.reqInfoEditForm.quoteDateRange) {
        // 日付初期化
        this.dateInit();
        // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
        // 一式データの場合、一式を選択
        if (!!this.RowData && this.RowData.length > 0) {
          let aobASetExist = this.RowData.some((item) => item.aobASet);
          this.reqInfoEditForm.aobASetOnly = aobASetExist;
          this.aobASetOnly = aobASetExist;
        }
        // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
      } else {
        // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
        // 一式機能の追加
        this.reqInfoEditForm.aobASetOnly = this.ReqInfoEditForm.aobASetOnly; //一式のみ
        this.aobASetOnly = this.reqInfoEditForm.aobASetOnly;
        // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
      }

      // 検索
      this.searchClick();
    },

    // 选中的行数据
    handleRowClick(row) {
      this.currentCell = row;
    },

    //テーブルの高さを設定する
    handleResize() {
      this.detailHeight = getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT,
        DIALOG_LINE_HEIGHT,
        30
      );

      this.colArr = getEditColWidthArr(window.innerWidth, 4);
    },

    // クリアボタン
    clearClick() {
      if (this.isAdd) {
        this.reqInfoEditForm.rbCusInfo = "";
      }
    },

    //参照ボタン
    customerReferenceClick() {
      if (!this.isAdd) {
        return;
      }

      var arr = this.reqInfoEditForm.rbCusInfo?.split(":");
      var sbCusCode = arr?.length > 0 ? arr[0] : "";

       // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
      var filterCustomerList = this.filterCustomerListProc(this.requestProductForm);
      // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑

      ShowCustomerReferenceDialog(
        // UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
        // { cusCode: sbCusCode },
        {
          cusCode: sbCusCode,
          requestFlg: true,
          filterCustomerList: filterCustomerList,
        },
        // 請求製品選択の得意先選択画面の初期データの変更
        // UPD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑
        t("resource.numberEditInfo.customerReferenceView"),
        (target) => {
          if (!!target) {
            this.reqInfoEditForm.rbCusInfo = target;
            // this.getCusCalculateDateProc();
          }
        }
      );
    },

    //确定ボタン
    confirmClick() {
      if (this.currentCell.length >= 1) {
        // 得意先情報の選択チェック
        if (!this.selectCheck()) {
          Modal.showWarning("", t("message.REQUEST_INFO.CUS_SELECT_FAILED"), {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          });
          return;
        }

        // 請求製品情報の取得
        this.getReqDetailInfoData();
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }

      // フォーカス削除
      this.$refs.confirmBtn.$el.blur();
    },

    // 詳細画面選択のデータ選択チェックボックス
    checkedProcess() {
      if (!!this.RowData) {
        this.RowData.forEach((row) => {
          for (let index = 0; index < this.requestProductForm.length; index++) {
            const element = this.requestProductForm[index];

            //詳細画面選択のデータ選択チェックボックス
            if (row.sbSendNo == element.sbSendNo) {
              this.$nextTick(() => {
                this.$refs.requestProductForm.toggleRowSelection(
                  this.requestProductForm[index],
                  true
                );
              });
            }
          }
        });
      }
    },

    // 請求予定日
    findMinDateInRow() {
      let minDate = new Date(this.currentCell[0].rbRequestExpectedDate);

      this.currentCell.forEach((row) => {
        const date = new Date(row.rbRequestExpectedDate);
        if (date < minDate) {
          minDate = date;
        }
      });

      return formatDateToString(minDate);
    },

    // ダイアログを閉じる
    close() {
      this.$emit("cancel");
    },

    // 検索
    searchClick() {
      // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
      // 一式機能の追加
      this.reqInfoEditForm.aobASetOnly = this.aobASetOnly; //一式のみ
      // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑

      // 請求製品情報の取得
      getReqProductInfo(this.reqInfoEditForm)
        .then((res) => {
          this.requestProductForm = res;

          // 詳細画面選択のデータ選択チェックボックス
          this.checkedProcess();

          Message.showSuccess(t("message.COMMON_MESSAGE.SEARCH_SUCCESS"));
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        })
        .finally(() => {
          setColumnWidth(this.columns, this.requestProductForm);
          this.loading = false;

          // フォーカス削除
          this.$refs.searchBtn.$el.blur();
        });
    },

    // 請求製品情報の取得
    getReqDetailInfoData() {
      // 請求製品情報の取得
      getReqDetailInfo(this.currentCell)
        .then((res) => {
          // this.reqInfoEditForm.rbCusInfo = this.currentCell[0].rbCusInfo;

          const result = {
            rbCusInfo: this.currentCell[0].rbCusInfo,
            rbRequestExpectedDate: this.findMinDateInRow(),
            rowData: res,
            ReqInfoEditForm: this.reqInfoEditForm,
          };

          this.$emit("ok", result);

          // this.requestProductForm = res;
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }

          const result = {
            rbCusInfo: this.reqInfoEditForm.rbCusInfo,
          };

          this.$emit("err", result);
        });
    },

    /**
     * el-table-column 自适应列宽
     * @param prop_label: 表名
     * @param table_data: 表格数据
     */
    flexColumnWidthFunc(label, prop) {
      return flexColumnWidth(label, prop, this.orderProductForm);
    },

    // 得意先情報の選択チェック
    selectCheck() {
      let result = true;

      let oldCusInfo = this.currentCell[0].rbCusInfo;
      this.currentCell.forEach((element) => {
        if (element.rbCusInfo != oldCusInfo) {
          result = false;
          return;
        }
      });

      return result;
    },

    // 請求日処理
    editDate(value) {
      if (Array.isArray(value) && value.length >= 2) {
        //請求日開始日
        this.reqInfoEditForm.startDate = value[0];
        // 請求日終了日
        this.reqInfoEditForm.endDate = value[1];
      } else {
        // 請求日開始日
        this.reqInfoEditForm.startDate = null;
        // 請求日終了日
        this.reqInfoEditForm.endDate = null;
      }
    },

    // 日付初期化
    dateInit() {
      // 請求日
      this.reqInfoEditForm.quoteDateRange = getNextMonthAgoArray();

      // 請求予定日(開始日)
      this.reqInfoEditForm.startDate = this.reqInfoEditForm.quoteDateRange[0];

      // 請求予定日(終了日)
      this.reqInfoEditForm.endDate = this.reqInfoEditForm.quoteDateRange[1];

      //請求予定日
      if (
        formatStringToDate(this.RbRequestExpectedDate) >
        formatStringToDate(this.reqInfoEditForm.endDate)
      ) {
        this.reqInfoEditForm.endDate = this.RbRequestExpectedDate;
      }

      if (
        formatStringToDate(this.RbRequestExpectedDate) <
        formatStringToDate(this.reqInfoEditForm.startDate)
      ) {
        this.reqInfoEditForm.startDate = this.RbRequestExpectedDate;
      }

      this.reqInfoEditForm.quoteDateRange = [
        this.reqInfoEditForm.startDate,
        this.reqInfoEditForm.endDate,
      ];
    },


    // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
    // 請求製品選択の得意先選択画面の初期データの変更
    // 請求可能な得意先リストのフィルタ
    filterCustomerListProc(requestProductForm) {
      const customerCodes = requestProductForm
        .map(item => item.rbCusInfo.split(':')[0])  // 得意先コードの取得
        .filter((value, index, self) => self.indexOf(value) === index);  // 重複排除
      return customerCodes;
    }
    // ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑

  },
};
</script>
<style scoped>
.el-form-item__label.custom-label {
  width: 20%;
}

.left-align {
  justify-content: left !important;
}

/* 设置按钮的文本颜色 */

/* 设置按钮的背景颜色 */
.el-button.button-default.custom-button.el-button--default {
  background-color: #ffffff; /* 你想要的背景颜色 */
  height: 27.5px;

  padding-top: 6.5px;
  border-radius: 1;
}
</style>
